import React from "react";
import Modal from "react-bootstrap/Modal";
import { useLeadDetail } from "../context/LeadDetailProvider";
import { useNavigate } from "react-router-dom";

const PurchasedLeadModal = ({show,handleClose ,idSelect }) => {
  const Navigate = useNavigate()
  const {setLeadFetch, leadFetch } = useLeadDetail();
    const handleSubscriptionShow = () => {
        handleClose()
        Navigate("/responses")
    };
    const handleStay = () => {
      handleClose()
      Navigate("/leads")
      setLeadFetch(!leadFetch)
  };


  return (
    <>
    <Modal show={show}>
          <Modal.Body>
            <div>
              <div className="account-created-pop">
                <h3>
                  You Purchased this Lead
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                  >
                    <rect
                      width="30"
                      height="30"
                      rx="15"
                      transform="matrix(-1 0 0 1 32 2)"
                      stroke="#337FE0"
                      strokeWidth="3"
                    />
                    <path
                      d="M23.5625 13.516L14.4916 21.2188L10.4375 17.1647"
                      stroke="#337FE0"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h3>
                <p>
                  We’ve emailed your contact details to the client and you can
                  now make contact!
                </p>
              </div>
            </div>
            <div className="account-created-action">
              <button onClick={handleStay} className="btn-outline">
                Stay Here
              </button>
              <button className="btn-fill" onClick={handleSubscriptionShow}>Go to Responses</button>
            </div>
          </Modal.Body>
        </Modal>
    </>
  )
}

export default PurchasedLeadModal
